import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import moment from 'moment';
import { useIntl, getLocale } from 'umi';
import Filter from '@/pages/intelligence/components/Filter';
import GenreSelector from '@intelligence/components/GenreSelectMiddleware';
import DigitalSegmentMultiple from '@/pages/intelligence/components/TeaSelector/DigitalSegmentMultiple';
import DataSourceSelector from '@/pages/intelligence/components/TeaSelector/AnnieSource';
import TipContext from '@/pages/home/components/TipContextComponents/TipContext';
import { STATIC_FILTER_CONFIGS, DEFAULT_FORM_VALUE } from './config';
import { feachTimeTypeToFilterTimeType } from '@/pages/intelligence/utils/common';
import { GuideGenreMarketProfileDelay as GuideGenreMarketProfile } from '@intelligence/components/UserGuide/GenreMarketProfile';
import ExportTable from '@/pages/intelligence/components/ExportTable';
import { marketProfileStats } from '@intelligence/v3/constants/downloadLogPoint';

export default function StatsFilters(props) {
  const {
    filterValues,
    onFilterChange,
    genreSource,
    total,
    genreName,
    genreType,
    order,
    orderBy,
    metricsList,
    entityType = '',
    genreOptions,
    tableDownloadParams,
  } = props;

  // console.debug('StatsFilters props:', props);

  const { formatMessage } = useIntl();
  const locale = getLocale();

  const formValueRef = useRef(JSON.parse(JSON.stringify(DEFAULT_FORM_VALUE)));

  const [inputList, setInputList] = useState([
    {
      ...STATIC_FILTER_CONFIGS.RANGE_TIME,
      entityType,
    },
  ]);

  const handleFilterChange = (value /** 筛选器数据 */, apiValue /** 筛选器转换后的数据 */) => {
    const { rangeTime } = apiValue || {};
    const { start_date, end_date, granularity } = rangeTime;
    onFilterChange({
      type: 'cascade',
      payload: {
        start_date,
        end_date,
        granularity,
      },
    });
  };

  const handleCustomFilterChange = (
    type: 'mutipleGenre' | 'singleGenre' | 'dataSource',
    value: any,
  ) => {
    onFilterChange({ type, payload: value });
  };

  const onReset = useCallback((value) => {
    // console.log(value);
  }, []);

  /** 时间筛选器值由父组件更新 */
  useEffect(() => {
    formValueRef.current = {
      rangeTime: {
        type: feachTimeTypeToFilterTimeType(filterValues.granularity),
        value: [moment(filterValues.startDate), moment(filterValues.endDate)],
      },
    };
  }, [filterValues.endDate]);

  // SensorTower没有日和周粒度数据，所以要强制切换为月粒度
  useEffect(() => {
    const dateRangeConfig = STATIC_FILTER_CONFIGS.RANGE_TIME;
    if (filterValues.dataSource === 'sensortower' && filterValues.dimension === 'companies') {
      Object.assign(dateRangeConfig, {
        typeList: ['month'],
        showSelectType: false,
      });
    } else {
      Object.assign(dateRangeConfig, {
        typeList: ['date', 'week', 'month'],
        showSelectType: true,
      });
    }
    setInputList([{
      ...dateRangeConfig,
      entityType,
    }]);
  }, [filterValues.dimension, filterValues.dataSource]);

  return (
    <>
      <div className="dbi-genre-rowtop">
        <div className="dbi-genre-rowtop-left">
          {filterValues.dimension === 'games' ? (
            <div className="search-item">
              <GenreSelector
                className="stats-select"
                source={'iegg'}
                mainGenres={filterValues.mainGenres}
                subGenres={filterValues.subGenres}
                onChange={(value: any[]) => handleCustomFilterChange('mutipleGenre', value)}
                disableAnnie={true}
                disableShortcut={false}
                isMarketProfilMobile={true}
                entityType={entityType}
              />
            </div>
          ) : (
            <div className="search-item">
              <DigitalSegmentMultiple
                key={'digital_segment_multiple'}
                value={filterValues.genres}
                locale={locale}
                marginStyle={{ marginBottom: 0 }}
                optionsOutList={genreOptions}
                isNeedHeaderTitle={false}
                btnNameKey={'dbi_top_genre'}
                onConfirm={(value: string[]) => handleCustomFilterChange('singleGenre', value)}
              />
            </div>
          )}
          <Filter
            value={formValueRef.current}
            inputList={inputList}
            onConfirm={handleFilterChange}
            onReset={onReset}
            defaultValue={DEFAULT_FORM_VALUE}
            showButton={false}
          />
          <TipContext
            className="tip-text-hd"
            tipText={formatMessage({
              id:
                filterValues.marketType === 'mobile'
                  ? 'dbi_genre_profile_stats_mobile_info'
                  : 'dbi_genre_profile_stats_mscience_info',
            })}
          />
          <DataSourceSelector
            type={'single'}
            key={'dataSourceSingle'}
            locale={locale}
            onConfirm={(value: string) => handleCustomFilterChange('dataSource', value)}
            value={filterValues.dataSource}
            isSearchItemMargin={true}
            isShowButtonLabel={true}
          />
        </div>
        <ExportTable
          downloadModalSize={820}
          entityType={filterValues.marketType}
          businessType={'marketProfile-stats'}
          isDisableDownload={false}
          total={total}
          downloadKey={'marketProfileStats'}
          tableParams={tableDownloadParams}
          useWebDownload={true}
          dataType={tableDownloadParams.dataType}
          downloadLogConfigKey={marketProfileStats?.[`${filterValues?.marketType}_${filterValues?.dimension}`]}
        />
      </div>
      {<GuideGenreMarketProfile />}
    </>
  );
}
